import {Component, Inject, OnInit} from '@angular/core';
import {SelectableItem} from "@app/modules/shared/components/selectable-list/selectable-list.component";
import { MatDialogRef } from "@angular/material/dialog";
import {SelectionCompleteEvent} from "@app/modules/shared/components/selectable.base";
import {
  SingleSelectedItemResult,
  SingleSelectionItem
} from "@app/modules/shared/components/single-selection-list/single-selection-list.component";
import {Seller} from "@app/modules/portal/models/portal.models";
import {SellerService} from "@app/modules/portal/services/seller.service";
import {BehaviorSubject, combineLatest, Subject} from "rxjs";
import {debounceTime, distinctUntilChanged, retry, switchMap, takeUntil} from "rxjs/operators";
import {SnackBarService} from "@app/modules/core/services/snack-bar.service";
import {TranslateService} from "@ngx-translate/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

export interface SellerSearchContext {
  filter?: string,
  pageSize?: number,
  pageNumber?: number,
  sort?: string,
  order?: string
}

export interface StoreSearchDialogData {
  allowCancel?:boolean
}

export interface StoreSearchDialogResult {
  storeName: string;
  dealerPerorgNo: number;
  sellerGroupId: number;
  storeId: number;
  success: boolean;
}

@Component({
  selector: 'iq-store-search',
  templateUrl: './store-search.dialog.html',
  styleUrls: ['./store-search.dialog.scss']
})
export class StoreSearchDialog implements OnInit {

  searchTerm: string;
  singleSelectableStore: SingleSelectionItem;
  allowCancel = false;
  searchStarted = false;
  searchSubject$ = new Subject<string>();

  constructor(public dialogRef: MatDialogRef<StoreSearchDialog>,
              @Inject(MAT_DIALOG_DATA) public data: StoreSearchDialogData, public sellerService: SellerService,
              private snackBarService: SnackBarService, private translate: TranslateService) {

    this.dialogRef.disableClose = true;
    this.allowCancel = data.allowCancel
    this.singleSelectableStore = {
      selectedValue: "",
      options: [],
      allowCancel: data.allowCancel
    }
  }

  ngOnInit() {
    this.searchSubject$.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if(value.length < 2){
        this.singleSelectableStore.options = [];
        return;
      }
      this.sellerService.getSellers(null, value).subscribe(sellers => {
          const sellerOptions = sellers.map(s => {
            return {
              value: s.sellerId,
              label: s.sellerName,
              dealerPerorgNo: s.dealerPerorgNo,
              sellerGroupId: s.sellerGroupId
            };
          });
          this.singleSelectableStore = {
            selectedValue: sellers.length > 1 ? sellers[0].sellerId : '',
            options: sellerOptions,
            allowCancel: this.allowCancel
          };
          this.searchStarted = true;
        },
        e => {
          this.snackBarService.flashError(
            this.translate.instant('errors.snackBar.generalTryAgain')
          );
        });
    })
  }

  onValidSelection(event: SelectionCompleteEvent<SingleSelectedItemResult>) {
    const storeId = Number(event.result.value);
    const store = this.singleSelectableStore.options.find(
      s => s.value === storeId
    );
    const storeName = store.label;
    const dealerPerorgNo = store.dealerPerorgNo;
    const sellerGroupId = store.sellerGroupId
    this.dialogRef.close({
      result: true,
      storeId,
      storeName,
      dealerPerorgNo,
      sellerGroupId
    })
  }

  onExit() {
    this.dialogRef.close({result: false});
  }

  onInput() {
      this.searchSubject$.next(this.searchTerm);
  }

}
